import styled from 'styled-components'

export const ContentContainer = styled.div`
  background: ${({ theme }) => theme.colours.bgLight};
  padding: 35px 25px;
  border-radius: 5px;
  box-shadow: 0 20px 30px 0 rgba(0, 0, 0, 0.15);
`
